var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocusignLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 815.21364 815.21364",
    id: "svg83",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g81",
    transform: "matrix(2.5329184,0,0,2.5329184,276.60696,-0.25261559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 139.5,139.5 V 189 c 0,2.6 -2.1,4.7 -4.7,4.7 H 4.7 C 2.1,193.7 0,191.6 0,189 V 59 c 0,-2.6 2.1,-4.7 4.7,-4.7 h 49.4 v 80.5 c 0,2.6 2.1,4.7 4.7,4.7 z",
    id: "path75",
    style: {
      fill: "#4c00ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 193.7,69.7 c 0,41.6 -24.3,69.7 -54.2,69.8 V 87.1 c 0,-1.5 -0.6,-3 -1.7,-4 L 110.6,55.9 c -1.1,-1.1 -2.5,-1.7 -4,-1.7 H 54.2 V 4.8 c 0,-2.6 2.1,-4.7 4.7,-4.7 h 73.3 C 167,0 193.7,28 193.7,69.7 Z",
    id: "path77",
    style: {
      fill: "#ff5252"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 137.8,83 c 1.1,1.1 1.7,2.5 1.7,4 v 52.4 H 58.9 c -2.6,0 -4.7,-2.1 -4.7,-4.7 V 54.2 h 52.4 c 1.5,0 3,0.6 4,1.7 z",
    id: "path79"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocusignLogo);
export default __webpack_public_path__ + "static/media/docusign-logo.741d80ce9eac769702f7b931cc406d78.svg";
export { ForwardRef as ReactComponent };